import { Itinerary } from '../../../types/Itinerary';
import { RootState } from '../../reducer';

export const selectItineraryTemplates = (state: RootState): Itinerary[] =>
  state.itineraryTemplates.itineraryTemplates;

export const selectCityItineraryTemplates = (
  state: RootState,
  citySlug: string
) => {
  return selectItineraryTemplates(state).filter(
    item => item.citySlug === citySlug
  );
};

export const selectItineraryTemplate = (state: RootState, id: string) => {
  return selectItineraryTemplates(state).find(item => item.id === id);
};

export const selectAreCityItineraryTemplatesLoading = (
  state: RootState,
  citySlug: string
) => {
  return state.itineraryTemplates.cityTemplatesLoading.includes(citySlug);
};

export const selectHaveCityItineraryTemplatesLoaded = (
  state: RootState,
  citySlug: string
) => {
  return state.itineraryTemplates.cityTemplatesLoaded.includes(citySlug);
};
